var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "2350713a-beef-4cb8-aa61-0a3a8b03ef4a"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "51e2e010-8d6f-41e4-b15e-a8b7ca9551eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.18 0 0 6.18 537.89 536.88)",
    id: "2ac1b43a-622c-4a28-ac76-76ea02a2b920"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-88.59, -88.68)",
    d: "M 48.4048 155.191 L 51.7303 147.801 L 125.631 147.801 L 128.956 155.191 L 48.4048 155.191 Z M 58.5661 133.021 L 118.98 133.021 L 122.305 140.411 L 55.2406 140.411 L 58.5661 133.021 Z M 55.4254 101.613 C 55.4254 98.4724 57.8271 96.0706 60.9679 96.0706 C 64.1087 96.0706 66.5104 98.4724 66.5104 101.613 C 66.5104 104.754 64.1087 107.156 60.9679 107.156 C 57.8271 107.156 55.4254 104.754 55.4254 101.613 Z M 55.4254 25.8652 C 55.4254 21.8006 58.7509 18.4751 62.8154 18.4751 L 77.5955 18.4751 C 77.5955 16.4429 79.2583 14.7801 81.2905 14.7801 L 96.0706 14.7801 C 98.1029 14.7801 99.7656 16.4429 99.7656 18.4751 L 114.546 18.4751 C 118.61 18.4751 121.936 21.8006 121.936 25.8652 L 121.936 62.8154 C 121.936 64.8477 120.273 66.5104 118.241 66.5104 L 59.1204 66.5104 C 57.0881 66.5104 55.4254 64.8477 55.4254 62.8154 L 55.4254 25.8652 Z M 115.469 125.631 L 61.8916 125.631 L 65.2172 118.241 L 112.144 118.241 L 115.469 125.631 Z M 116.393 107.156 C 113.252 107.156 110.851 104.754 110.851 101.613 C 110.851 98.4724 113.252 96.0706 116.393 96.0706 C 119.534 96.0706 121.936 98.4724 121.936 101.613 C 121.936 104.754 119.534 107.156 116.393 107.156 Z M 120.273 118.241 L 121.936 118.241 C 128.033 118.241 133.021 113.252 133.021 107.156 L 133.021 22.1701 C 133.021 14.0411 126.37 7.39005 118.241 7.39005 L 59.1204 7.39005 C 50.9913 7.39005 44.3403 14.0411 44.3403 22.1701 L 44.3403 107.156 C 44.3403 113.252 49.3286 118.241 55.4254 118.241 L 57.0881 118.241 L 33.6247 169.971 L 41.7538 169.971 L 45.0793 162.581 L 132.097 162.581 L 135.423 169.971 L 143.552 169.971 L 120.273 118.241 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainActive);
export default __webpack_public_path__ + "static/media/Train_active.f69edff412d620477edfe141acc6e9ab.svg";
export { ForwardRef as ReactComponent };